<!-- the scope this section needs is not the layout's, so it renders nothing until that file arrives: hold its height
     or the deferred map below jumps into the viewport and loads itself -->
<ng-template #loading>
  <rma-skeleton-grid [bones]="1" heightClass="h-136" />
</ng-template>

<ng-container *transloco="let t; prefix: scope; loadingTpl: loading">
  @let propertyType = selectedPropertyType();
  @let propertyTypeName = propertyType ? (propertyType | apiToTranslation: propertyTypesScope | transloco: { count: 1 }) : null;
  <rma-comparison-table
    [heading]="propertyTypeName ? t('filteredTitle', { propertyType: propertyTypeName }) : t('title')"
    [subheading]="propertyTypeName ? t('filteredDescription', { propertyType: propertyTypeName }) : t('filterDescription')"
  >
    @if (propertyTypes().length > 0) {
      <mat-form-field rmaComparisonTableActions class="w-64 bg-white" appearance="outline" floatLabel="always" subscriptSizing="dynamic">
        <mat-label>{{ t('propertyTypeLabel') }}</mat-label>
        <mat-select
          [value]="propertyType"
          [placeholder]="t('propertyTypeAll')"
          (selectionChange)="propertyTypeChange.emit($event.value)"
          data-id="sales-performance-property-type"
        >
          <mat-option [value]="null">{{ t('propertyTypeAll') }}</mat-option>
          @for (option of propertyTypes(); track option) {
            <mat-option [value]="option">{{ option | apiToTranslation: propertyTypesScope | transloco: { count: 1 } }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @for (row of rows(); track row.key) {
      <rma-comparison-table-row [label]="t(row.labelKey)" [indented]="row.indented ?? false">
        @for (agent of agents(); track agent.agentCode) {
          <rma-comparison-table-cell>
            @let value = row.value(agent, propertyType);
            @if (showsValue(row, value)) {
              @switch (row.format) {
                @case ('currency') {
                  <span class="font-semibold uppercase" [attr.data-id]="'sales-performance-' + row.key">{{
                    value | shortNumber: 1 : true
                  }}</span>
                }
                @case ('days') {
                  <span class="font-semibold" [attr.data-id]="'sales-performance-' + row.key">{{
                    t('days', { count: (value | number) })
                  }}</span>
                }
                @default {
                  @if (row.link?.(agent); as href) {
                    <a
                      class="font-semibold"
                      [attr.data-id]="'sales-performance-' + row.key"
                      [routerLink]="[href]"
                      [queryParams]="propertiesQueryParams"
                    >
                      {{ value | number }}
                    </a>
                  } @else {
                    <span class="font-semibold" [attr.data-id]="'sales-performance-' + row.key">{{ value | number }}</span>
                  }
                }
              }
            } @else {
              <span data-id="sales-performance-empty">&mdash;</span>
            }
          </rma-comparison-table-cell>
        }
      </rma-comparison-table-row>
    }
  </rma-comparison-table>
</ng-container>
